import React, { useEffect, useRef, useState, createContext, useContext } from "react";
import Lenis from "lenis";

const LenisCtx = createContext(null);

export const useLenis = () => useContext(LenisCtx);

export function SmoothScroll({ children }) {
  const lenisRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.0,
      touchMultiplier: 1.5,
      lerp: 0.09,
    });
    lenisRef.current = lenis;
    setReady(true);

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const rid = requestAnimationFrame(raf);

    document.documentElement.classList.add("lenis-smooth");
    return () => {
      cancelAnimationFrame(rid);
      lenis.destroy();
      document.documentElement.classList.remove("lenis-smooth");
    };
  }, []);

  return <LenisCtx.Provider value={lenisRef}>{children}</LenisCtx.Provider>;
}
